module.exports = __webpack_public_path__ + "static/img/manual_ja_27.b6c6e3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_27.png
// module id = vV+s
// module chunks = 4